const state = {
  categories: [
    // {
    //   code: "zone_overview",
    //   title: "Zone Overview",
    //   icon: "fas fa-binoculars",
    //   tabs: [
    //     {
    //       title: "GIS",
    //       code: "gis",
    //       url: "https://au1gis.solutions.arcadis.com/arcgis/apps/webappviewer/index.html?id=51ffb878a4ae4095a87fcd3f03476bbb"
    //     },
    //     {
    //       title: "INSIGHTS",
    //       code: "insights",
    //       url: "https://app.powerbi.com/reportEmbed?reportId=59f03a19-b23d-4134-b75d-704ab03f46fa&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
    //     },
    //     {
    //       title: "DOWNLOAD FILES",
    //       code: "download_files",
    //       url: "https://arcadiso365.sharepoint.com/:f:/r/sites/AAP-Team2/Proposal/Proposals/SRAPC_Tender/Processed%20Data?csf=1&web=1"
    //       // url: "https://recap.autodesk.com/project/c61c4b8d7b34465d89fbca0d467343b0"
    //       // url: "http://360-images.geodemosolutions.com/"
    //     }
    //   ]
    // },
    // {
    //   code: "its",
    //   title: "ITS",
    //   icon: "fas fa-desktop",
    //   tabs: [
    //     {
    //       title: "INVENTORY",
    //       code: "inventory",
    //       // url: "https://app.powerbi.com/reportEmbed?reportId=bbe3bfda-e8e0-4759-a5c3-22c58faafae5&appId=be22bbd5-ab0d-4d0a-ac88-df283664e319&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
    //       url: "https://app.powerbi.com/reportEmbed?reportId=dfcb1801-167d-4606-beb0-8bc74a16dd9a&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
    //     },
    //     {
    //       title: "CONDITION",
    //       code: "condition",
    //       url: "https://app.powerbi.com/reportEmbed?reportId=73e4723f-52b0-4811-8f82-dbf81ee831f0&appId=be22bbd5-ab0d-4d0a-ac88-df283664e319&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
    //     },
    //     {
    //       title: "GIS",
    //       code: "gis",
    //       // url: "https://au1gis.solutions.arcadis.com/arcgis/apps/webappviewer/index.html?id=4c58516148344b3faac8195cb792a5e7"
    //       url: "https://au1gis.solutions.arcadis.com/arcgis/apps/opsdashboard/index.html#/a031bd8e1cb243078c9fd02d0451407a"
    //     },
    //     // {
    //     //   title: "CONOPS",
    //     //   code: "conops",
    //     //   url: "https://srapc-under-construction.geodemosolutions.com"
    //     // },
    //     {
    //       title: "FMECA",
    //       code: "fmeca",
    //       url: "https://srapc-under-construction.geodemosolutions.com"
    //     },
    //     {
    //       title: "RAW DATA",
    //       code: "raw_data",
    //       url: "https://app.powerbi.com/reportEmbed?reportId=144591d1-ea08-49bd-9cbb-e416ad2f22e7&appId=be22bbd5-ab0d-4d0a-ac88-df283664e319&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
    //     }
    //   ]
    // },
    // {
    //   code: "pavements",
    //   title: "Pavements",
    //   icon: "fas fa-road",
    //   tabs: [
    //     {
    //       title: "INVENTORY",
    //       code: "inventory",
    //       // url: "https://app.powerbi.com/reportEmbed?reportId=a836d997-5559-42fa-9c0f-a27252ae5346&appId=be22bbd5-ab0d-4d0a-ac88-df283664e319&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
    //       url: "https://app.powerbi.com/reportEmbed?reportId=53a52226-87ff-41b5-844e-4c8bb0760ed7&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
    //     },
    //     {
    //       title: "CONDITION",
    //       code: "condition",
    //       // url: "https://app.powerbi.com/reportEmbed?reportId=7eeaa13e-5154-4e38-932b-632c0e584be8&appId=be22bbd5-ab0d-4d0a-ac88-df283664e319&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
    //       url: "https://app.powerbi.com/reportEmbed?reportId=881c07a9-5433-447b-aad8-ca149fb03d56&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
    //     },
    //     {
    //       title: "GIS",
    //       code: "gis",
    //       url: "https://au1gis.solutions.arcadis.com/arcgis/apps/webappviewer/index.html?id=c25d4626080246cc99f412eac5ca58a5"
    //     },
    //     // {
    //     //   title: "CONOPS",
    //     //   code: "conops",
    //     //   url: "https://srapc-under-construction.geodemosolutions.com"
    //     // },
    //     {
    //       title: "FMECA",
    //       code: "fmeca",
    //       url: "https://srapc-under-construction.geodemosolutions.com"
    //     },
    //     {
    //       title: "RAW DATA",
    //       code: "raw_data",
    //       url: "https://app.powerbi.com/reportEmbed?reportId=f046d0d3-dfb6-449e-b07e-389f6b4aa9af&appId=be22bbd5-ab0d-4d0a-ac88-df283664e319&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
    //     }
    //   ]
    // },
    // {
    //   code: "corridors",
    //   title: "Corridors",
    //   icon: "fas fa-th-large",
    //   tabs: [
    //     {
    //       title: "INVENTORY",
    //       code: "inventory",
    //       // url: "https://app.powerbi.com/reportEmbed?reportId=c35adfae-75ea-4dc0-92cb-68c15bf50f06&appId=be22bbd5-ab0d-4d0a-ac88-df283664e319&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
    //       url: "https://app.powerbi.com/reportEmbed?reportId=3ddde391-2f04-4b1c-bd42-e3be4eaee733&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
    //     },
    //     {
    //       title: "CONDITION",
    //       code: "condition",
    //       url: "https://srapc-under-construction.geodemosolutions.com"
    //     },
    //     {
    //       title: "GIS",
    //       code: "gis",
    //       url: "https://au1gis.solutions.arcadis.com/arcgis/apps/webappviewer/index.html?id=2b887c7f3066445e91917e4fafcbe891"
    //     },
    //     // {
    //     //   title: "CONOPS",
    //     //   code: "conops",
    //     //   url: "https://srapc-under-construction.geodemosolutions.com"
    //     // },
    //     {
    //       title: "FMECA",
    //       code: "fmeca",
    //       url: "https://srapc-under-construction.geodemosolutions.com"
    //     },
    //     {
    //       title: "RAW DATA",
    //       code: "raw_data",
    //       url: "https://app.powerbi.com/reportEmbed?reportId=1e742e57-4838-4dc9-90d5-c4bcd9188571&appId=be22bbd5-ab0d-4d0a-ac88-df283664e319&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
    //     }
    //   ]
    // },
    // {
    //   code: "bridges",
    //   title: "Bridges",
    //   icon: "fas fa-wave-square",
    //   tabs: [
    //     {
    //       title: "INVENTORY",
    //       code: "inventory",
    //       // url: "https://app.powerbi.com/reportEmbed?reportId=8461e82d-39b0-4486-b58b-d93421c27fd7&appId=be22bbd5-ab0d-4d0a-ac88-df283664e319&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
    //       // url: "https://app.powerbi.com/reportEmbed?reportId=443732c7-8cfd-4306-9299-a786405456d0&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
    //       url: "https://app.powerbi.com/reportEmbed?reportId=7cab6073-563b-4ea0-9011-6b163bd8ad30&appId=be22bbd5-ab0d-4d0a-ac88-df283664e319&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
    //     },
    //     {
    //       title: "CONDITION",
    //       code: "condition",
    //       // url: "https://srapc-under-construction.geodemosolutions.com"
    //       url: "https://app.powerbi.com/reportEmbed?reportId=6f106191-7b64-4e83-90c8-5e97090a8706&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
    //     },
    //     {
    //       title: "GIS",
    //       code: "gis",
    //       // url: "https://au1gis.solutions.arcadis.com/arcgis/apps/webappviewer/index.html?id=a62b325bb8b2418e83a6e19f906ebe83"
    //       url: "https://au1gis.solutions.arcadis.com/arcgis/apps/MapSeries/index.html?appid=888af4150afd4df7a69a299778e5a59c&preview"
    //     },
    //     // {
    //     //   title: "CONOPS",
    //     //   code: "conops",
    //     //   url: "https://srapc-under-construction.geodemosolutions.com"
    //     // },
    //     {
    //       title: "FMECA",
    //       code: "fmeca",
    //       url: "https://srapc-under-construction.geodemosolutions.com"
    //     },
    //     {
    //       title: "RAW DATA",
    //       code: "raw_data",
    //       url: "https://srapc-under-construction.geodemosolutions.com"
    //     }
    //   ]
    // }
    {
      code: "cherry_tree",
      title: "Cherry Tree",
      icon: "fas fa-binoculars",
      tabs: [
        {
          title: "Site Insight",
          code: "cherry_site_insight",
          url: "https://au1gis.solutions.arcadis.com/arcgis/apps/webappviewer/index.html?id=9270a54e5aae476ab2d94ebb4afcf201"
        },
        {
          title: "Site Investigation",
          code: "cherry_site_investigation",
          url: "https://au1gis.solutions.arcadis.com/arcgis/apps/webappviewer/index.html?id=f6d16ea885e64c8592f55204452ff072"
        },
        {
          title: "Ecology Monitoring",
          code: "cherry_ecology_monitoring",
          url: "https://au1gis.solutions.arcadis.com/arcgis/apps/opsdashboard/index.html#/05b6ccb8b37f45c0b36443dea3269dd6"
        },
        {
          title: "Site 360",
          code: "cherry_site_360",
          url: "https://tap5.geodemosolutions.com/#/login"
        },
        // {
        //   title: "Environment",
        //   code: "cherry_environment",
        //   url: "https://au1gis.solutions.arcadis.com/arcgis/apps/webappviewer/index.html?id=765a260c817a457baf5578d5efc5c406"
        // },
        {
          title: "Comment",
          code: "cherry_comment_review",
          url: "https://comment-envi-tool.geodemosolutions.com/"
        },
        {
          title: "Generate Report",
          code: "cherry_generate_report",
          url: "https://cherryreportgenerator.geodemosolutions.com/"
        },
        {
          title: "Document Issue",
          code: "cherry_document_issue",
          url: "https://cherry-report-upload.geodemosolutions.com/"
        }
      ]
    },
    {
      code: "flyers_creek",
      title: "Flyers Creek",
      icon: "fas fa-desktop",
      tabs: [
        {
          title: "Site Insight",
          code: "flyers_site_insight",
          url: "https://under-construction.geodemosolutions.com/"
        }
      ]
    },
  ],
  subCategories: {
    zone_overview: [
      {
        title: "Overview",
        tabs: [
          {
            title: "Overview",
            code: "overview",
            url: ""
          }
        ]
      }
    ],
    its: [
      {
        title: "Overview",
        tabs: [
          {
            title: "Overview",
            code: "overview",
            url: ""
          }
        ]
      },
      {
        title: "Enforcement System",
        tabs: []
      },
      {
        title: "Advanced Warning Sign",
        tabs: []
      },
      {
        title: "CCTV Camera",
        tabs: []
      },
      {
        title: "Changeable Message Signs",
        tabs: []
      },
      {
        title: "Emergency Phone",
        tabs: []
      },
      {
        title: "Over Height Detection System",
        tabs: []
      },
      {
        title: "Over Speed Detection System",
        tabs: []
      },
      {
        title: "School Zone",
        tabs: []
      },
      {
        title: "Street Lightning",
        tabs: []
      },
      {
        title: "Tidal Flow System",
        tabs: []
      },
      {
        title: "Traffic Control System",
        tabs: []
      },
      {
        title: "Traffic Monitoring Unit",
        tabs: []
      },
      {
        title: "Travel Time Information System",
        tabs: []
      },
      {
        title: "Variable Message Sign",
        tabs: []
      },
      {
        title: "Variable Speed Limit Sign",
        tabs: []
      },
      {
        title: "Vehicle Detection Class System",
        tabs: []
      },
      {
        title: "Weight in Motion System",
        tabs: []
      },
      {
        title: "Interchange Assets",
        tabs: []
      }
    ],
    pavements: [
      {
        title: "Overview",
        code: "overview",
        tabs: [
          {
            title: "Overview",
            url: "https://app.powerbi.com/reportEmbed?reportId=e79eab57-dc4b-4345-b569-24c200164baf&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
          }
        ]
      },
      {
        title: "Land Management",
        tabs: []
      },
      {
        title: "Rocond Maintenance Segment",
        tabs: []
      }
    ],
    corridors: [
      {
        title: "Overview",
        tabs: [
          {
            title: "Overview",
            code: "overview",
            url: "https://app.powerbi.com/reportEmbed?reportId=73baf6b5-d127-4a14-a0af-fa45aafd91ee&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
          }
        ]
      },
      {
        title: "Culvert",
        tabs: []
      },
      {
        title: "Cycleway",
        tabs: []
      },
      {
        title: "Kerb Gutter",
        tabs: []
      },
      {
        title: "Median",
        tabs: []
      },
      {
        title: "Noisewall",
        tabs: [
          {
            title: "INSIGHT",
            code: "insight",
            url: "https://app.powerbi.com/reportEmbed?reportId=949dd2eb-5af0-4652-bb44-3f5706f18ed7&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
          },
          {
            title: "GIS",
            code: "gis",
            url: "img/assets/tabs/GISTab.png"
          },
          {
            title: "CONOPS",
            code: "conops",
            url: ""
          },
          {
            title: "FMECA",
            code: "fmeca",
            url: ""
          },
          {
            title: "RAW DATA",
            code: "raw_data",
            url: ""
          }
        ]
      },
      {
        title: "Offroad Paved Area",
        tabs: []
      },
      {
        title: "Open Drainage",
        tabs: []
      },
      {
        title: "Roadside Landscaping",
        tabs: []
      },
      {
        title: "Roadside Rest Area",
        tabs: []
      },
      {
        title: "Safety Barrier",
        tabs: []
      },
      {
        title: "Safety Ramps",
        tabs: []
      },
      {
        title: "Slope Site",
        tabs: []
      },
      {
        title: "Stormwater Quality Improvement",
        tabs: []
      },
      {
        title: "Sub Soil Drainage",
        tabs: []
      }
    ],
    bridges: [
      {
        title: "Overview",
        tabs: [
          {
            title: "Overview",
            code: "overview",
            url: "https://app.powerbi.com/reportEmbed?reportId=9505b31d-e109-4083-94b2-287ff2d4d7c2&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
          }
        ]
      },
      {
        title: "Bridge",
        tabs: []
      },
      {
        title: "Bridge Size Culvert",
        tabs: []
      },
      {
        title: "Electrical Mechanical Assets",
        tabs: []
      },
      {
        title: "Lifts",
        tabs: []
      },
      {
        title: "Tunnel Structure",
        tabs: []
      }
    ]
  },
  defaultTabs: [
    {
      title: "INSIGHT",
      code: "insight",
      url: "https://app.powerbi.com/reportEmbed?reportId=1fcb7c77-721a-4d62-bce8-ca353cd80e68&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
    },
    {
      title: "GIS",
      code: "gis",
      url: "img/assets/tabs/GISTab.png"
    },
    {
      title: "CONOPS",
      code: "conops",
      url: "img/assets/tabs/GISTab.png"
    },
    {
      title: "FMECA",
      code: "fmeca",
      url: "img/assets/tabs/ConopsTab.png"
    },
    {
      title: "RAW DATA",
      code: "raw_data",
      url: "img/assets/tabs/ConopsTab.png"
    }
  ],
  currentSelectedCategory: "",
  currentSelectedSubCategory: "",
  currentSelectedTab: {
  },
  activeTabFlags: {
    insightsSection: false,
    inventorySection: false,
    conditionSection: false,
    gisSection: false,
    conopsSection: false,
    fmecaSection: false,
    raw_dataSection: false,
    download_filesSection: false,
    cherry_site_insightSection: false,
    cherry_site_investigationSection: false,
    cherry_ecology_monitoringSection: false,
    cherry_site_360Section: false,
    cherry_environmentSection: false,
    cherry_comment_reviewSection: false,
    cherry_generate_reportSection: false,
    cherry_document_issueSection: false,
    flyers_site_insightSection: false
  }
}

function initialState() {
  return {
    categories: [
      // {
      //   code: "zone_overview",
      //   title: "Zone Overview",
      //   icon: "fas fa-binoculars",
      //   tabs: [
      //     {
      //       title: "GIS",
      //       code: "gis",
      //       url: "https://au1gis.solutions.arcadis.com/arcgis/apps/webappviewer/index.html?id=51ffb878a4ae4095a87fcd3f03476bbb"
      //     },
      //     {
      //       title: "INSIGHTS",
      //       code: "insights",
      //       url: "https://app.powerbi.com/reportEmbed?reportId=59f03a19-b23d-4134-b75d-704ab03f46fa&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
      //     },
      //     {
      //       title: "DOWNLOAD FILES",
      //       code: "download_files",
      //       url: "https://arcadiso365.sharepoint.com/:f:/r/sites/AAP-Team2/Proposal/Proposals/SRAPC_Tender/Processed%20Data?csf=1&web=1"
      //       // url: "https://recap.autodesk.com/project/c61c4b8d7b34465d89fbca0d467343b0"
      //       // url: "http://360-images.geodemosolutions.com/"
      //     }
      //   ]
      // },
      // {
      //   code: "its",
      //   title: "ITS",
      //   icon: "fas fa-desktop",
      //   tabs: [
      //     {
      //       title: "INVENTORY",
      //       code: "inventory",
      //       // url: "https://app.powerbi.com/reportEmbed?reportId=bbe3bfda-e8e0-4759-a5c3-22c58faafae5&appId=be22bbd5-ab0d-4d0a-ac88-df283664e319&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
      //       url: "https://app.powerbi.com/reportEmbed?reportId=dfcb1801-167d-4606-beb0-8bc74a16dd9a&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
      //     },
      //     {
      //       title: "CONDITION",
      //       code: "condition",
      //       url: "https://app.powerbi.com/reportEmbed?reportId=73e4723f-52b0-4811-8f82-dbf81ee831f0&appId=be22bbd5-ab0d-4d0a-ac88-df283664e319&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
      //     },
      //     {
      //       title: "GIS",
      //       code: "gis",
      //       // url: "https://au1gis.solutions.arcadis.com/arcgis/apps/webappviewer/index.html?id=4c58516148344b3faac8195cb792a5e7"
      //       url: "https://au1gis.solutions.arcadis.com/arcgis/apps/opsdashboard/index.html#/a031bd8e1cb243078c9fd02d0451407a"
      //     },
      //     // {
      //     //   title: "CONOPS",
      //     //   code: "conops",
      //     //   url: "https://srapc-under-construction.geodemosolutions.com"
      //     // },
      //     {
      //       title: "FMECA",
      //       code: "fmeca",
      //       url: "https://srapc-under-construction.geodemosolutions.com"
      //     },
      //     {
      //       title: "RAW DATA",
      //       code: "raw_data",
      //       url: "https://app.powerbi.com/reportEmbed?reportId=144591d1-ea08-49bd-9cbb-e416ad2f22e7&appId=be22bbd5-ab0d-4d0a-ac88-df283664e319&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
      //     }
      //   ]
      // },
      // {
      //   code: "pavements",
      //   title: "Pavements",
      //   icon: "fas fa-road",
      //   tabs: [
      //     {
      //       title: "INVENTORY",
      //       code: "inventory",
      //       // url: "https://app.powerbi.com/reportEmbed?reportId=a836d997-5559-42fa-9c0f-a27252ae5346&appId=be22bbd5-ab0d-4d0a-ac88-df283664e319&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
      //       url: "https://app.powerbi.com/reportEmbed?reportId=53a52226-87ff-41b5-844e-4c8bb0760ed7&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
      //     },
      //     {
      //       title: "CONDITION",
      //       code: "condition",
      //       // url: "https://app.powerbi.com/reportEmbed?reportId=7eeaa13e-5154-4e38-932b-632c0e584be8&appId=be22bbd5-ab0d-4d0a-ac88-df283664e319&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
      //       url: "https://app.powerbi.com/reportEmbed?reportId=881c07a9-5433-447b-aad8-ca149fb03d56&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
      //     },
      //     {
      //       title: "GIS",
      //       code: "gis",
      //       url: "https://au1gis.solutions.arcadis.com/arcgis/apps/webappviewer/index.html?id=c25d4626080246cc99f412eac5ca58a5"
      //     },
      //     // {
      //     //   title: "CONOPS",
      //     //   code: "conops",
      //     //   url: "https://srapc-under-construction.geodemosolutions.com"
      //     // },
      //     {
      //       title: "FMECA",
      //       code: "fmeca",
      //       url: "https://srapc-under-construction.geodemosolutions.com"
      //     },
      //     {
      //       title: "RAW DATA",
      //       code: "raw_data",
      //       url: "https://app.powerbi.com/reportEmbed?reportId=f046d0d3-dfb6-449e-b07e-389f6b4aa9af&appId=be22bbd5-ab0d-4d0a-ac88-df283664e319&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
      //     }
      //   ]
      // },
      // {
      //   code: "corridors",
      //   title: "Corridors",
      //   icon: "fas fa-th-large",
      //   tabs: [
      //     {
      //       title: "INVENTORY",
      //       code: "inventory",
      //       // url: "https://app.powerbi.com/reportEmbed?reportId=c35adfae-75ea-4dc0-92cb-68c15bf50f06&appId=be22bbd5-ab0d-4d0a-ac88-df283664e319&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
      //       url: "https://app.powerbi.com/reportEmbed?reportId=3ddde391-2f04-4b1c-bd42-e3be4eaee733&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
      //     },
      //     {
      //       title: "CONDITION",
      //       code: "condition",
      //       url: "https://srapc-under-construction.geodemosolutions.com"
      //     },
      //     {
      //       title: "GIS",
      //       code: "gis",
      //       url: "https://au1gis.solutions.arcadis.com/arcgis/apps/webappviewer/index.html?id=2b887c7f3066445e91917e4fafcbe891"
      //     },
      //     // {
      //     //   title: "CONOPS",
      //     //   code: "conops",
      //     //   url: "https://srapc-under-construction.geodemosolutions.com"
      //     // },
      //     {
      //       title: "FMECA",
      //       code: "fmeca",
      //       url: "https://srapc-under-construction.geodemosolutions.com"
      //     },
      //     {
      //       title: "RAW DATA",
      //       code: "raw_data",
      //       url: "https://app.powerbi.com/reportEmbed?reportId=1e742e57-4838-4dc9-90d5-c4bcd9188571&appId=be22bbd5-ab0d-4d0a-ac88-df283664e319&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
      //     }
      //   ]
      // },
      // {
      //   code: "bridges",
      //   title: "Bridges",
      //   icon: "fas fa-wave-square",
      //   tabs: [
      //     {
      //       title: "INVENTORY",
      //       code: "inventory",
      //       // url: "https://app.powerbi.com/reportEmbed?reportId=8461e82d-39b0-4486-b58b-d93421c27fd7&appId=be22bbd5-ab0d-4d0a-ac88-df283664e319&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
      //       // url: "https://app.powerbi.com/reportEmbed?reportId=443732c7-8cfd-4306-9299-a786405456d0&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
      //       url: "https://app.powerbi.com/reportEmbed?reportId=7cab6073-563b-4ea0-9011-6b163bd8ad30&appId=be22bbd5-ab0d-4d0a-ac88-df283664e319&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
      //     },
      //     {
      //       title: "CONDITION",
      //       code: "condition",
      //       // url: "https://srapc-under-construction.geodemosolutions.com"
      //       url: "https://app.powerbi.com/reportEmbed?reportId=6f106191-7b64-4e83-90c8-5e97090a8706&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
      //     },
      //     {
      //       title: "GIS",
      //       code: "gis",
      //       // url: "https://au1gis.solutions.arcadis.com/arcgis/apps/webappviewer/index.html?id=a62b325bb8b2418e83a6e19f906ebe83"
      //       url: "https://au1gis.solutions.arcadis.com/arcgis/apps/MapSeries/index.html?appid=888af4150afd4df7a69a299778e5a59c&preview"
      //     },
      //     // {
      //     //   title: "CONOPS",
      //     //   code: "conops",
      //     //   url: "https://srapc-under-construction.geodemosolutions.com"
      //     // },
      //     {
      //       title: "FMECA",
      //       code: "fmeca",
      //       url: "https://srapc-under-construction.geodemosolutions.com"
      //     },
      //     {
      //       title: "RAW DATA",
      //       code: "raw_data",
      //       url: "https://srapc-under-construction.geodemosolutions.com"
      //     }
      //   ]
      // }
      {
        code: "cherry_tree",
        title: "Cherry Tree",
        icon: "fas fa-binoculars",
        tabs: [
          {
            title: "Site Insight",
            code: "cherry_site_insight",
            url: "https://au1gis.solutions.arcadis.com/arcgis/apps/webappviewer/index.html?id=9270a54e5aae476ab2d94ebb4afcf201"
          },
          {
            title: "Site Investigation",
            code: "cherry_site_investigation",
            url: "https://au1gis.solutions.arcadis.com/arcgis/apps/webappviewer/index.html?id=f6d16ea885e64c8592f55204452ff072"
          },
          {
            title: "Ecology Monitoring",
            code: "cherry_ecology_monitoring",
            url: "https://au1gis.solutions.arcadis.com/arcgis/apps/opsdashboard/index.html#/05b6ccb8b37f45c0b36443dea3269dd6"
          },
          {
            title: "Site 360",
            code: "cherry_site_360",
            url: "https://tap5.geodemosolutions.com/#/login"
          },
          // {
          //   title: "Environment",
          //   code: "cherry_environment",
          //   url: "https://au1gis.solutions.arcadis.com/arcgis/apps/webappviewer/index.html?id=765a260c817a457baf5578d5efc5c406"
          // },
          {
            title: "Comment",
            code: "cherry_comment_review",
            url: "https://comment-envi-tool.geodemosolutions.com/"
          },
          {
            title: "Generate Report",
            code: "cherry_generate_report",
            url: "https://cherryreportgenerator.geodemosolutions.com/"
          },
          {
            title: "Document Issue",
            code: "cherry_document_issue",
            url: "https://cherry-report-upload.geodemosolutions.com/"
          }
        ]
      },
      {
        code: "flyers_creek",
        title: "Flyers Creek",
        icon: "fas fa-desktop",
        tabs: [
          {
            title: "Site Insight",
            code: "flyers_site_insight",
            url: "https://under-construction.geodemosolutions.com/"
          }
        ]
      },
    ],
    subCategories: {
      zone_overview: [
        {
          title: "Overview",
          tabs: [
            {
              title: "Overview",
              code: "overview",
              url: ""
            }
          ]
        }
      ],
      its: [
        {
          title: "Overview",
          tabs: [
            {
              title: "Overview",
              code: "overview",
              url: ""
            }
          ]
        },
        {
          title: "Enforcement System",
          tabs: []
        },
        {
          title: "Advanced Warning Sign",
          tabs: []
        },
        {
          title: "CCTV Camera",
          tabs: []
        },
        {
          title: "Changeable Message Signs",
          tabs: []
        },
        {
          title: "Emergency Phone",
          tabs: []
        },
        {
          title: "Over Height Detection System",
          tabs: []
        },
        {
          title: "Over Speed Detection System",
          tabs: []
        },
        {
          title: "School Zone",
          tabs: []
        },
        {
          title: "Street Lightning",
          tabs: []
        },
        {
          title: "Tidal Flow System",
          tabs: []
        },
        {
          title: "Traffic Control System",
          tabs: []
        },
        {
          title: "Traffic Monitoring Unit",
          tabs: []
        },
        {
          title: "Travel Time Information System",
          tabs: []
        },
        {
          title: "Variable Message Sign",
          tabs: []
        },
        {
          title: "Variable Speed Limit Sign",
          tabs: []
        },
        {
          title: "Vehicle Detection Class System",
          tabs: []
        },
        {
          title: "Weight in Motion System",
          tabs: []
        },
        {
          title: "Interchange Assets",
          tabs: []
        }
      ],
      pavements: [
        {
          title: "Overview",
          code: "overview",
          tabs: [
            {
              title: "Overview",
              url: "https://app.powerbi.com/reportEmbed?reportId=e79eab57-dc4b-4345-b569-24c200164baf&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            }
          ]
        },
        {
          title: "Land Management",
          tabs: []
        },
        {
          title: "Rocond Maintenance Segment",
          tabs: []
        }
      ],
      corridors: [
        {
          title: "Overview",
          tabs: [
            {
              title: "Overview",
              code: "overview",
              url: "https://app.powerbi.com/reportEmbed?reportId=73baf6b5-d127-4a14-a0af-fa45aafd91ee&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            }
          ]
        },
        {
          title: "Culvert",
          tabs: []
        },
        {
          title: "Cycleway",
          tabs: []
        },
        {
          title: "Kerb Gutter",
          tabs: []
        },
        {
          title: "Median",
          tabs: []
        },
        {
          title: "Noisewall",
          tabs: [
            {
              title: "INSIGHT",
              code: "insight",
              url: "https://app.powerbi.com/reportEmbed?reportId=949dd2eb-5af0-4652-bb44-3f5706f18ed7&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            },
            {
              title: "GIS",
              code: "gis",
              url: "img/assets/tabs/GISTab.png"
            },
            {
              title: "CONOPS",
              code: "conops",
              url: ""
            },
            {
              title: "FMECA",
              code: "fmeca",
              url: ""
            },
            {
              title: "RAW DATA",
              code: "raw_data",
              url: ""
            }
          ]
        },
        {
          title: "Offroad Paved Area",
          tabs: []
        },
        {
          title: "Open Drainage",
          tabs: []
        },
        {
          title: "Roadside Landscaping",
          tabs: []
        },
        {
          title: "Roadside Rest Area",
          tabs: []
        },
        {
          title: "Safety Barrier",
          tabs: []
        },
        {
          title: "Safety Ramps",
          tabs: []
        },
        {
          title: "Slope Site",
          tabs: []
        },
        {
          title: "Stormwater Quality Improvement",
          tabs: []
        },
        {
          title: "Sub Soil Drainage",
          tabs: []
        }
      ],
      bridges: [
        {
          title: "Overview",
          tabs: [
            {
              title: "Overview",
              code: "overview",
              url: "https://app.powerbi.com/reportEmbed?reportId=9505b31d-e109-4083-94b2-287ff2d4d7c2&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
            }
          ]
        },
        {
          title: "Bridge",
          tabs: []
        },
        {
          title: "Bridge Size Culvert",
          tabs: []
        },
        {
          title: "Electrical Mechanical Assets",
          tabs: []
        },
        {
          title: "Lifts",
          tabs: []
        },
        {
          title: "Tunnel Structure",
          tabs: []
        }
      ]
    },
    defaultTabs: [
      {
        title: "INSIGHT",
        code: "insight",
        url: "https://app.powerbi.com/reportEmbed?reportId=1fcb7c77-721a-4d62-bce8-ca353cd80e68&autoAuth=true&ctid=7f90057d-3ea0-46fe-b07c-e0568627081b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
      },
      {
        title: "GIS",
        code: "gis",
        url: "img/assets/tabs/GISTab.png"
      },
      {
        title: "CONOPS",
        code: "conops",
        url: "img/assets/tabs/GISTab.png"
      },
      {
        title: "FMECA",
        code: "fmeca",
        url: "img/assets/tabs/ConopsTab.png"
      },
      {
        title: "RAW DATA",
        code: "raw_data",
        url: "img/assets/tabs/ConopsTab.png"
      }
    ],
    currentSelectedCategory: "",
    currentSelectedSubCategory: "",
    currentSelectedTab: {
    },
    activeTabFlags: {
      insightsSection: false,
      inventorySection: false,
      conditionSection: false,
      gisSection: false,
      conopsSection: false,
      fmecaSection: false,
      raw_dataSection: false,
      download_filesSection: false,
      cherry_site_insightSection: false,
      cherry_site_investigationSection: false,
      cherry_ecology_monitoringSection: false,
      cherry_site_360Section: false,
      cherry_environmentSection: false,
      cherry_comment_reviewSection: false,
      cherry_generate_reportSection: false,
      cherry_document_issueSection: false,
      flyers_site_insightSection: false
    }
  }
}

const mutations = {
  upCounter(state) {
    state.counter += 1
  },
  setSelectedZone(state, payload) {
    var selectedZone = state.zones.filter(obj=>obj.code == payload)[0]
    state.selectedZone = selectedZone
  },
  setCategoriesFromZone(state, payload) {
    var categories = state.categories[payload]
    state.selectedCategories = categories
  },
  setSelectedLine(state, payload) {
    var selectedLine = state.lines.filter(obj=>obj.code == payload)[0]
    state.selectedLine = selectedLine
    console.log(selectedLine);
  },
  setSelectedStations(state, payload) {
    state.selectedStations = state.stations[payload]
  },
  setActiveTabFlags(state, payload) {

    state.activeTabFlags.insightsSection = false
    state.activeTabFlags.inventorySection = false
    state.activeTabFlags.conditionSection = false
    state.activeTabFlags.gisSection = false
    state.activeTabFlags.conopsSection = false
    state.activeTabFlags.fmecaSection = false
    state.activeTabFlags.raw_dataSection = false

    state.activeTabFlags[payload] = true
  },
  setSelectedPortfolio(state, payload) {
    var selectedPortfolio = state.portfolios.filter(obj=>obj.code == payload)[0]
    state.selectedPortfolio = selectedPortfolio
  },
  setSelectedProjects(state, payload) {
    state.selectedProjects = state.projects[payload]
  },
  setCurrentSelectedSubCategory(state, payload) {
    state.currentSelectedSubCategory = payload
  },
  setCurrentSelectedCategory(state, payload) {
    state.currentSelectedCategory = payload
  },
  setCurrentSelectedTab(state, payload) {
    // if(payload.title != "Overview"){
    //
    //   // if(state.currentSelectedSubCategory == "Noisewall"){
    //   if(state.subCategories[state.currentSelectedCategory.code].filter(obj=>obj.title == state.currentSelectedSubCategory)[0].tabs.length == 0){
    //     payload.tabs = state.defaultTabs
    //   }
    //   // else{
    //   //   payload.tabs = state.defaultTabs
    //   // }
    //
    // }
    state.currentSelectedTab = payload
  },
}

const actions = {

}

const getters = {

}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
